$(document).ready(function () {

  $(".accordion-wrap")
    .find("div[role|='button']")
    .click(function () {
      $(this).parent().parent().toggleClass("active-accordion");
      var selected = $(this).next(".pannel");
      if (selected.is(":hidden")) {
        $(this).next(".pannel").slideDown();
        $(this).toggleClass("active");
      } else {
        $(this).next(".pannel").slideUp();
        $(this).toggleClass("active");
      }
      $(this).find(".wk-small-caret").toggleClass("rotate");
    });

    $('.menu-drawer__menu-item').on('click', function() {
      var $this = $(this);
      var $parentWrap = $this.closest('.drawer-accordion-wrap');
      var $pannel = $parentWrap.find('.pannel');
      
      // Toggle active class and panel display for clicked item only
      $parentWrap.toggleClass('active');
      $pannel.slideToggle();
  });


  function refreshCardHeight() {
    var maxHeight = 0;
    if ($('.featured-card-height').length > 0) {
      var card = ".featured-card-height";
    }

    $(card).css('height', '');
    $(card).each(function () {
      if ($(this).height() > maxHeight) {
        maxHeight = $(this).height();
      }
    });
    $(card).height(maxHeight);
  }
  refreshCardHeight();
  $(window).resize(function () {
    refreshCardHeight();
  });


  // create a code to set cookies in javascript
  function setCookie() {
    // Check for share parameter in URL and set cookie if found
    if (window.location.href.includes('share')) {
      const shareValue = window.location.href.split('share=')[1];
      // Set cookie with 2 hour expiration
      document.cookie = `share=${shareValue}; expires=${new Date(Date.now() + 2 * 60 * 60 * 1000).toUTCString()}; path=/`;
    }

    // Get existing share value before updating other cookies
    const existingShareCookie = document.cookie.split('; ').find(row => row.startsWith('share='));
    const shareValue = existingShareCookie ? existingShareCookie.split('=')[1] : null;
    
    // Set/update other cookies
    if (document.cookie.indexOf("Country") >= 0) {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf('=');
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        if (name.trim() == 'Country') {
          document.cookie = `Country=${Shopify.country}; path=/`;
        }
        if (name.trim() == 'Language') {
          document.cookie = `Language=${Shopify.locale}; path=/`;
        }
      }
    }

    // Set default cookies if not exist
    document.cookie = `Country=${Shopify.country}; path=/`;
    document.cookie = `Language=${Shopify.locale}; path=/`;

    // Restore share cookie if it existed
    if (shareValue && !window.location.href.includes('share')) {
      document.cookie = `share=${shareValue}; expires=${new Date(Date.now() + 2 * 60 * 60 * 1000).toUTCString()}; path=/`;
    }
  }

  setCookie();


  function setoriginCookie(name, value, maxAge, path, domain, secure) {
    let cookieString = `${name}=${value}`;
    if (maxAge) cookieString += `; max-age=${maxAge}`;
    if (domain) cookieString += `; domain=${domain}`;
    if (path) cookieString += `; path=${path}`;
    if (secure) cookieString += `; secure`;

    const expiry = new Date(Date.now() + (maxAge * 1000)).toUTCString() || 'Tue, 19 Jan 2038 03:14:07 GMT';

    document.cookie = `${cookieString}; expires=${expiry}`;
  }

  if (window.location.href.includes('origin=')) {
    const origin = window.location.href.split('origin=')[1];
    setoriginCookie('origin', origin, 604800, '/', '.wakuli.com', true);

    const originCookie = document.cookie.split(';').find(cookie => cookie.includes('origin='));
    

    var orderNote = {
      attributes: {
        "Origin": originCookie
      }
    }
    $.ajax({
      url: "/cart/update.js",
      method: "POST",
      dataType: "json",
      data: orderNote,
      async: false
    })
      .done(function (data) {
        // console.log(data);
      })
      .fail(function (error) {
        console.log(error);
      });

  }

  $(document).on('click', '.button', function () {
    // Get all the buttons on the page
    const buttons = document.querySelectorAll('a');
    const subscription_link = document.querySelector('.cart-drawer').getAttribute('data-subscription_link');
    // Loop through each button
    buttons.forEach(button => {
      // Check if the href contains "quizflow"
      const cartCookie = document.cookie.split('; ').find(row => row.startsWith('cart='));
      const languageCookie = document.cookie.split('; ').find(row => row.startsWith('Language='));
      const countryCookie = document.cookie.split('; ').find(row => row.startsWith('Country='));

      const cookie_language = languageCookie ? languageCookie.split('=')[1] : null;
      const cookie_country = countryCookie ? countryCookie.split('=')[1] : null;
      const cookie_share_id = document.cookie.split('; ').find(row => row.startsWith('share='));
      const cartId = cartCookie ? cartCookie.split('=')[1] : null;
      if (button.href && button.href.includes('checkout.wakuli.com/checkout')) {
        button.href = '';
        button.href = `${subscription_link}?cart=${cartId}&country=${cookie_country}&language=${cookie_language}&direct_checkout=true&${cookie_share_id}`;
      }
      else if (button.href && button.href.includes('quizflow')) 
      {
        button.href = '';
        button.href = `https://checkout.wakuli.com/?cart=${cartId}&country=${cookie_country}&language=${cookie_language}&${cookie_share_id}`;
      }
    });
  });




});




